import * as React from 'react';
import './ProductsNavigation.css';

interface Props {
    cursorIndex: number;
    nextCursor?: string;
    prevCursor?: string;
    next: () => void;
    prev: () => void;
}

class ProductsNavigation extends React.PureComponent<Props> {
    public render(): JSX.Element {
        const prevClass = `prev-page-${window.location.pathname.slice(1)} ${!this.prevEnabled() ? 'disabled' : ''}`;
        const nextClass = `next-page-${window.location.pathname.slice(1)} ${!this.nextEnabled() ? 'disabled' : ''}`;

        return (
            <div className="pagination">
                <span className={prevClass} onClick={this.onPrev}>
                    {'<'} Prev
                </span>
                <span className={nextClass} onClick={this.onNext}>
                    Next {'>'}
                </span>
            </div>
        );
    }

    private onPrev = (): void => {
        if (this.prevEnabled()) {
            this.props.prev();
        }
    };

    private onNext = (): void => {
        if (this.nextEnabled()) {
            this.props.next();
        }
    };

    private prevEnabled = (): boolean => this.props.prevCursor !== undefined || this.props.cursorIndex === 1;

    private nextEnabled = (): boolean => this.props.nextCursor !== undefined;
}

export default ProductsNavigation;



// WEBPACK FOOTER //
// ./src/view/common/ProductsNavigation.tsx